import { ValidationDefinitionDTO } from "../DTO/validationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateValidationDefinitionRequest extends BasicRequest{
   
    public validationDefinition! : ValidationDefinitionDTO;
    
    constructor(){
        super();
    }
}